import { sortItems } from './timeline.js';
import type { MediaItem } from './types.js';

export interface BestRule {
  /** Whether a 5-star rating alone counts as a pick. Rajath's call (PRD US-03). */
  includeFiveStar: boolean;
}

export const DEFAULT_BEST_RULE: BestRule = { includeFiveStar: false };

export function isPick(item: MediaItem, rule: BestRule = DEFAULT_BEST_RULE): boolean {
  if (item.hidden) return false;
  if (item.favorite) return true;
  if (item.pick) return true;
  if (rule.includeFiveStar && (item.rating ?? 0) >= 5) return true;
  return false;
}

/** Picks and owner favorites, in the order they happened. */
export function selectBest(items: MediaItem[], rule: BestRule = DEFAULT_BEST_RULE): MediaItem[] {
  return sortItems(items.filter((item) => isPick(item, rule)));
}
